export default class DynamicMenuList {
  constructor(section) {
    this.el = section.el;
    this.toggles = this.el.querySelectorAll('[data-menu-list-toggle]');

    for (let i = 0; i < this.toggles.length; i++) {
      this.toggles[i].addEventListener('click', (event) => {
        const links = event.currentTarget.parentNode.querySelectorAll('[data-menu-list-hidden]');
        const text = event.currentTarget.querySelectorAll('.menu-list-link-text');

        for (let i = 0; i < text.length; i++) {
          text[i].classList.toggle('menu-list-link-hidden');
        }

        for (let i = 0; i < links.length; i++) {
          links[i].classList.toggle('menu-list-link-hidden');
        }
      });
    }
  }

  onSectionUnload() {

  }
}
